/**
 * Escapes special regex characters in a string so it can be safely
 * used inside a `new RegExp(...)` constructor.
 */
export function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
